import axios from 'axios';
import { constants } from "../../Constants";
import { setup } from 'axios-cache-adapter';

let APIKit = axios.create({
    baseURL: constants.API,
    timeout: 10000,
});

const getApi = setup({
    baseURL: constants.API,
    cache: {
        maxAge: 15 * 60 * 1000
    }
})

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

let headers = {
    "mobile": getCookie("mobile"),
    "token": getCookie("token"),
    "is_site": 1
}

export const addToCartApi = async (postData) => {
    postData.mobile = getCookie("mobile");
    postData.token = getCookie("token");
    try {
        const response = await axios.post(constants.API + "/carts/addToCart", postData, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getCartItem = async (from_cart = false) => {
    let payloads = { "mobile": getCookie("mobile"), "token": getCookie("token") };
    if (from_cart) {
        payloads.from_cart = true;
    }
    try {
        const response = await axios.post(constants.API + "/carts/viewCart", payloads, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getSliderList = async () => {
    try {
        const response = await getApi.get(constants.API + "/slider/list", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getCommon = async (type) => {
    try {
        const response = await getApi.get(constants.API + "/common/getCommonSetting/" + type, { headers });
        if (response.data && response.data.status) {
            return response.data.result;
        } else {
            return "";
        }
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getMenuList = async () => {
    try {
        const response = await getApi.get(constants.API + "/menu/list?website=true", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", error);
        return false;
    }
}

export const getMenuProductList = async (prod, limit, page) => {

    try {
        const response = await getApi.get(constants.API + "/product/menuWithProduct?from=website", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getUserAddress = async () => {
    if (!getCookie("mobile") && !getCookie("token") && getCookie("is_logged_in") !== "yes") {
        return false;
    }
    let payload = { "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/getUserAddress", payload, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const applyCouponApi = async (couponData) => {
    let payload = { ...couponData, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/carts/applyCoupon", payload, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getCouponDeals = async () => {
    try {
        const response = await getApi.get(constants.API + "/deals/list", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const removeCouponApi = async (cart_id) => {
    let payload = { ...cart_id, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/carts/removeCoupon", payload, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const clearCartApi = async (cart_id) => {
    let payload = { ...cart_id, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/carts/clearCart", payload, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getProductDetailWithCustomize = async (id) => {
    try {
        const response = await axios.get(constants.API + "/product/getWithCustomize/" + id, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const sentOtpForVerification = async (payload) => {
    try {
        const response = await axios.post(constants.API + "/sendOtpForRegistration", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const verifyOtp = async (payload) => {
    if (getCookie("token")) {
        payload = {
            ...payload,
            token: getCookie('token')
        }
    }
    try {
        const response = await axios.post(constants.API + "/verifyOtp", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const placeOrder = async (data) => {
    let payload = { ...data, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/orders/placeOrder", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const orderPayment = async (data) => {
    let payload = { ...data, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/orders/orderPayment", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const verifyOrderPayment = async (data) => {
    let payload = { ...data, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/orders/verifyOrderPayment", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const capturePayment = async (data) => {
    let payload = { ...data, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/orders/capturePayment", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getLocationList = async () => {
    try {
        const response = await getApi.get(constants.API + "/location/activeList", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const getUniqueOrder = async (payload) => {
    try {
        const response = await axios.post(constants.API + "/orders/getUniqueOrder", payload, { headers });
        return response;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}
export const orderDataList = async (data) => {
    let query = "";
    if (data) {
        query = "?" + data;
    }
    try {
        const response = await axios.get(constants.API + "/orders-list" + query, { headers });
        return response.data;
    } catch (error) {
        // window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}
export const failedOrderDataList = async () => {
    let query = "";
    if (getCookie("branch")) {
        query = "?branch=" + getCookie("branch")
    }
    try {
        const response = await axios.get(constants.API + "/orders/failedOrderDataList" + query, { headers });
        return response.data;
    } catch (error) {
        // window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}
export const changeOrderStatusApi = async (payload) => {
    try {
        const response = await axios.post(constants.API + "/orders/changeOrderStatus", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}
export const getUserByMobile = async (mobile = "") => {
    let payload = { "mobile": getCookie("mobile") };
    if (mobile) {
        payload = { "mobile": mobile };
    }
    try {
        const response = await getApi.post(constants.API + "/user/getUserByMobile", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const applyLoyaltyPointsApi = async () => {
    try {
        const response = await axios.get(constants.API + "/carts/applyLoyaltyPoints", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const removeLoyaltyPointsApi = async () => {
    try {
        const response = await axios.get(constants.API + "/carts/removeLoyaltyPoints", { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const changeDeliveryType = async (type) => {
    try {
        if(!headers.mobile && !headers.token) {
            window.location.reload();
            return false;
        }
        const response = await axios.get(constants.API + "/carts/delivery-type/" + type, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const missedOrderAdd = async (data) => {
    let payload = { ...data, "mobile": getCookie("mobile"), "token": getCookie("token") };
    try {
        const response = await axios.post(constants.API + "/missedOrders/add", payload, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const myOrders = async (page = 1, limit = 10, sort_by = "created", sort_direction = "DESC") => {
    if (!getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }
    let query = `?page=${page}&limit=${limit}&sort_by=${sort_by}&sort_direction=${sort_direction}`;

    try {
        const response = await axios.get(constants.API + "/my-orders" + query, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const paymentHistory = async (page = 1, limit = 10, payment_method = "COD") => {
    if (!getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }
    let query = `?page=${page}&limit=${limit}&payment_method=${payment_method}`;

    try {
        const response = await axios.get(constants.API + "/payment-history" + query, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const myAddress = async (page = 1, limit = 10) => {
    if (!getCookie("token") || !getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }
    let query = `?page=${page}&limit=${limit}`;

    try {
        const response = await axios.get(constants.API + "/address" + query, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const delAddress = async (id) => {
    if (!getCookie("token") || !getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }
    let query = `?id=${id}`;

    try {
        const response = await axios.delete(constants.API + "/address" + query, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const addAddress = async (data) => {
    if (!getCookie("token") || !getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }

    try {
        const response = await axios.post(constants.API + "/address", data, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const updateAddress = async (data) => {
    if (!getCookie("token") || !getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }

    try {
        const response = await axios.put(constants.API + "/address", data, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const addTip = async (data) => {

    try {
        const response = await axios.get(constants.API + "/carts/add-tip/" + data, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const userLogin = async (data) => {
    try {
        const response = await axios.post(constants.API + "/userLogin", data, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}


export const searchProduct = async (text) => {
    let query = `?search=${text}&is_site=1`;

    try {
        const response = await axios.get(constants.API + "/product-search" + query, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const downloadInvoice = async (id) => {
    let query = `?id=${id}`;

    try {
        const response = await axios.get(constants.API + "/print-order" + query, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");;
        return false;
    }
}

export const repeatOrder = async (id) => {
    if (!window.getCookie("token") || !window.getCookie("mobile") || window.getCookie("otp_verified") !== "yes") {
        return false;
    }
    let query = `?id=${id}`;

    try {
        const response = await axios.get(constants.API + "/repeat-order" + query, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const changePayment = async (id, mode) => {
    if (!window.getCookie("token")) {
        return false;
    }
    let query = `?id=${id}&mode=${mode}`;

    try {
        const response = await axios.get(constants.API + "/change-payment" + query, { headers });
        return response.data;
    } catch (error) {
        return false;
    }
}

export const paymentModeList = async (query) => {
    let url = "/payment-mode";
    if (query) {
        url += query;
    }
    try {
        const response = await getApi.get(constants.API + url, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");
        return false;
    }
}

export const appDownloadCountStore = async (type) => {
    try {
        const response = await getApi.get(constants.API + "/store-app-download?type=" + type, { headers });
        return response.data;
    } catch (error) {
        window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");
        return false;
    }
}

export const addUserRouteAnalytics = async (data) => {
    try {
        const response = await getApi.post(constants.API + "/analytics_route/add", {
            ...data
        }, {
            headers: {
                token: JSON.parse(localStorage.user).token
            }
        });
        return response.data;
    } catch (error) {
        // window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");
        return false;
    }
}

export const addUtmeAnalytics = async (data) => {
    try {
        const response = await getApi.post(constants.API + "/utm/add_analytics", {
            ...data
        });
        return response.data;
    } catch (error) {
        // window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");
        return false;
    }
}

export const fetchBranchFromAddress  = async (_address) => {
    try {
        const response = await getApi.post(constants.API + "/getBranchByAddress?address=" + _address);
        return response.data;
    } catch (error) {
        // window.createNotification("error", navigator.onLine ? "Something went wrong" : "Please check your internet connection");
        return false;
    }
}


export default APIKit;